"use strict";

var HttpRangeFetcher = require('./httpRangeFetcher');

module.exports = {
  HttpRangeFetcher: HttpRangeFetcher
};